
class giftingJS {
	constructor() {

		this.productForm = document.querySelector(".product-form");
	
		this.checkSwatch();
	}
	
	checkSwatch(){
		document.querySelectorAll(".swatch [data-handle]").forEach(ele=>{
			
			if(ele.value == "3 months"){
			 setTimeout(() => {
				ele.click(); 
			 }, 1000);	
			}
		})
	}
	
  }
  new giftingJS();
